<template>
    <div class="language-container">
        <button class="select-language"
                v-bind:class="{ 'layout-language-select': languageListOpen }"
                v-on:click="openListLanguage">
        <span class="select-language-label">
            <span class="language-flag">{{flags[language.id]}}</span>{{language.id}}
        </span>
            <i class="fal icon icon-language" v-bind:class="[languageListOpen ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </button>
        <ul class="layout-list-language" v-if="languageListOpen">
            <li v-for="(item, index) in options" v-on:click="updateLanguage(item.id)" :title="item.text">
                <span class="language-flag">{{flags[item.id]}}</span>{{item.id}}
            </li>
        </ul>
    </div>
</template>

<script>
    import app from "../main"
    import getLanguage from "../language"
    export default {
        name: "Language",
        data(){
          const langId = getLanguage(["FR", "EN", "PL", "ES", "IT", "DE", "PT", "NL"]);
          this.createCookies(langId)
          return {
            language: {id: langId},
            flags: {
              FR: '🇫🇷',
              EN: '🇬🇧',
              PL: '🇵🇱',
              ES: '🇪🇸',
              IT: '🇮🇹',
              DE: '🇩🇪',
              PT: '🇵🇹',
              NL: '🇳🇱',
            },
            options: [{
              id: 'FR',
              text: 'FR - ' + this.$t("authentication.language.fr")
            }, {
              id: 'EN',
              text: 'EN - ' + this.$t("authentication.language.en")
            }, {
              id: 'PL',
              text: 'PL - ' + this.$t("authentication.language.pl")
            }, {
              id: 'ES',
              text: 'ES - ' + this.$t("authentication.language.es")
            }, {
              id: 'IT',
              text: 'IT - ' + this.$t("authentication.language.it")
            }, {
              id: 'DE',
              text: 'DE - ' + this.$t("authentication.language.de")
            }, {
              id: 'PT',
              text: 'PT - ' + this.$t("authentication.language.pt")
            }, {
              id: 'NL',
              text: 'NL - ' + this.$t("authentication.language.nl")
            }
            ],
            languageListOpen: false,
            languageTargetClasses: ["select-language", "layout-list-language"],
          }
        },
        methods: {
            updateLanguage(language){
                this.lang = app
                this.createCookies(language)
                this.lang.set(language)
                this.languageListOpen = false
                this.language = {id: getLanguage(["FR", "EN", "PL", "ES", "IT", "DE", "PT", "NL"])}
            },
            createCookies(language){
                let cookie_name = "language"
                let cookie_value = language
                document.cookie = cookie_name + "=" + cookie_value
            },

            clickedOnSearchDrawerFct(event) {
                const elementClasses = event.target
                return this.languageTargetClasses.find(elem => elementClasses.classList.contains(elem)
                    || (elementClasses.parentElement !== null)
                    && elementClasses.parentElement.classList.contains(elem))
            },

            closeSearchWhenClickingElsewhere(event) {
                const clickedOnSearchDrawer = this.clickedOnSearchDrawerFct(event)
                if (!clickedOnSearchDrawer) {
                    this.openListLanguage(event)
                } else {
                    return
                }
            },

            openListLanguage(event){
                this.languageListOpen = !this.languageListOpen

                const clickedElement = event.target
                if (!clickedElement) return

                const clickedOnSearchDrawer = this.clickedOnSearchDrawerFct(event)
                const ctrl = this
                if (this.languageListOpen && !window.onclick) {
                    window.onclick = (event) => {
                        ctrl.closeSearchWhenClickingElsewhere(event)
                    }
                } else if (!clickedOnSearchDrawer) {
                    this.languageListOpen = false
                    window.onclick = null
                }
            },
        }
    }
</script>
